// theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
	palette: {
		primary: {
			main: "#191e4a",
			contrastText: "#ffffff",
		},
	},
});

export default theme;
